import { COLORS } from './constants';

/** Color thresholds matching dd.hauserhq.com exactly */
const scoreToBarColor = (score: number): string => {
  if (score >= 86) return '#f3f3f3';
  if (score >= 77) return '#5AE9FF';
  if (score >= 68) return COLORS.moderate;  // #FFF981
  if (score >= 59) return COLORS.urgent;    // #FF9A4D
  return COLORS.critical;                    // #DB5282
};

export interface CategoryBarData {
  label: string;
  score: number | null;
}

interface MobileCategoryBarsProps {
  categories: CategoryBarData[];
}

export const MobileCategoryBars = ({ categories }: MobileCategoryBarsProps) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 30, marginBottom: 30 }}>
    {categories.map(({ label: rawLabel, score }) => {
      const isNa = score === null;
      const barColor = isNa ? 'rgba(255,255,255,0.15)' : scoreToBarColor(score);
      const label = rawLabel === 'HVAC SYSTEMS' ? 'HVAC' : rawLabel;
      return (
        <div
          key={label}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          {/* Category label */}
          <span
            style={{
              fontSize: 11,
              fontWeight: 600,
              color: isNa ? 'var(--tx-faint)' : 'var(--tx-muted)',
              width: 100,
              flexShrink: 0,
            }}
          >
            {label}
          </span>
          {/* Bar */}
          <div
            style={{
              flex: 1,
              height: 6,
              background: 'var(--tx-fill-2)',
              borderRadius: 3,
              overflow: 'hidden',
            }}
          >
            {!isNa && (
              <div
                style={{
                  width: `${score}%`,
                  height: '100%',
                  background: barColor,
                  borderRadius: 3,
                  transition: 'width 0.6s ease',
                }}
              />
            )}
          </div>
          {/* Score */}
          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: barColor,
              width: 28,
              textAlign: 'right',
              flexShrink: 0,
            }}
          >
            {isNa ? 'N/A' : score}
          </span>
        </div>
      );
    })}
  </div>
);
